import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";

// Legacy /sign-in entry - redirects to /log-in or /sign-up based on mode.
// Preserves search params (next, plan).
export function SignInPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const mode = sp.get("mode");
    sp.delete("mode");
    const search: Record<string, string> = {};
    for (const [k, v] of sp.entries()) search[k] = v;
    navigate({
      to: mode === "signup" ? "/sign-up" : "/log-in",
      search: search as never,
      replace: true,
    });
  }, [navigate]);
  return null;
}
